/* eslint-disable react/prop-types */
import { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import Swal from "sweetalert2";
import "./styles.css";

const ModalRedesSociais = ({ isOpen, onClose, onSave }) => {

  const [redesAdicionadas, setRedesAdicionadas] = useState([]);
  
  const [redeSelecionada, setRedeSelecionada] = useState("Instagram");
  const [link, setLink] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const isUrlValida = (string) => {
    try {
      new URL(string);
      return true;
    // eslint-disable-next-line no-unused-vars
    } catch (_) {
      return false;
    }
  };

  const handleAdicionarRede = () => {
    if (!link) {
      Swal.fire("Atenção", "Por favor, preencha o link.", "warning");
      return;
    }

    if (!isUrlValida(link)) {
      Swal.fire("Link inválido", "Por favor, insira um link válido (ex: https://...).", "error");
      return;
    }

    setRedesAdicionadas([...redesAdicionadas, { rede: redeSelecionada, link }]);
    setLink("");
  };

  const handleRemoverRede = (index) => {
    const novasRedes = [...redesAdicionadas];
    novasRedes.splice(index, 1);
    setRedesAdicionadas(novasRedes);
  };

  const handleSalvar = async () => {
    if (redesAdicionadas.length === 0) {
      Swal.fire("Atenção", "Adicione pelo menos uma rede social para salvar.", "warning");
      return;
    }
    
    setIsLoading(true);
    await onSave(redesAdicionadas);
    setIsLoading(false);
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>Cadastre suas Redes Sociais</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="redeSocialSelect">Rede Social</Label>
            <Input
              type="select"
              name="select"
              id="redeSocialSelect"
              value={redeSelecionada}
              onChange={(e) => setRedeSelecionada(e.target.value)}
            >
              <option value="Instagram">Instagram</option>
              <option value="Tiktok">TikTok</option>
              <option value="YouTube">YouTube</option>
              <option value="Facebook">Facebook</option>
              <option value="Threads">Threads</option>
              <option value="Kwai">Kwai</option>
              <option value="Twitter/X">Twitter/X</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="linkInput">Link do Perfil</Label>
            <div className="input-group">
              <Input
                type="url"
                id="linkInput"
                placeholder="https://redesocial.com/seu_usuario"
                value={link}
                onChange={(e) => setLink(e.target.value)}
              />
              <Button color="primary" onClick={handleAdicionarRede}>
                Adicionar
              </Button>
            </div>
          </FormGroup>
        </Form>

        {redesAdicionadas.length > 0 && (
          <ListGroup className="mt-3">
            {redesAdicionadas.map((item, index) => (
              <ListGroupItem key={index} className="d-flex justify-content-between align-items-center">
                <span><strong>{item.rede.charAt(0).toUpperCase() + item.rede.slice(1)}:</strong> {item.link}</span>
                <Button color="danger" size="sm" onClick={() => handleRemoverRede(index)}>
                  Remover
                </Button>
              </ListGroupItem>
            ))}
          </ListGroup>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClose} disabled={isLoading}>
          Fechar
        </Button>
        <Button color="success" onClick={handleSalvar} disabled={isLoading || redesAdicionadas.length === 0}>
          {isLoading ? "Salvando..." : "Salvar Redes Sociais"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalRedesSociais;